import script from "./KeyValueRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyValueRow.vue?vue&type=script&setup=true&lang=ts"

import "./KeyValueRow.vue?vue&type=style&index=0&id=2d357039&lang=scss&scoped=true"

import exportComponent from "../../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d357039"]])

export default __exports__